'use strict';

var React = require('react');
var NumberFormat = require('react-number-format');
var styles = require('@material-ui/core/styles');
var TextField = require('@material-ui/core/TextField');
var InputAdornment = require('@material-ui/core/InputAdornment');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var NumberFormat__default = /*#__PURE__*/_interopDefaultLegacy(NumberFormat);
var TextField__default = /*#__PURE__*/_interopDefaultLegacy(TextField);
var InputAdornment__default = /*#__PURE__*/_interopDefaultLegacy(InputAdornment);

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

var _excluded = ["onChange"];
var useStyles = styles.makeStyles(function(theme) {
  return {
    root: {
      "& > *": {
        margin: theme.spacing(0.5)
      }
    }
  };
});
var NumberFormatCustom = /* @__PURE__ */ React__default['default'].forwardRef(function NumberFormatCustom2(props, ref) {
  var onChange = props.onChange, other = _objectWithoutProperties(props, _excluded);
  React.useEffect(function() {
  }, []);
  var intScale = props.intScale;
  var withValueCap = function withValueCap2(inputObj) {
    var value = inputObj.value;
    intScale = intScale ? intScale : 16;
    if (Number(value) < Math.pow(10, intScale)) {
      var array = value.toString().split(".");
      if (array[1]) {
        if (array[1].length < props.decimalScale2) {
          return inputObj;
        }
      } else {
        return inputObj;
      }
    }
  };
  return /* @__PURE__ */ React__default['default'].createElement(NumberFormat__default['default'], _extends({}, other, {
    getInputRef: ref,
    onValueChange: function onValueChange(values) {
      onChange({
        target: {
          name: props.name,
          value: values.value
        }
      });
    },
    thousandSeparator: true,
    isNumericString: true,
    isAllowed: withValueCap,
    prefix: ""
  }));
});
function FormattedInputs(_ref) {
  var value = _ref.value, set_value = _ref.set_value, label = _ref.label, endAdornment = _ref.endAdornment, decimalScale = _ref.decimalScale, intScale = _ref.intScale, fullWidth = _ref.fullWidth, disabled = _ref.disabled, readOnly = _ref.readOnly;
  var classes = useStyles();
  var handleChange = function handleChange2(event) {
    set_value(event.target.value);
  };
  return /* @__PURE__ */ React__default['default'].createElement("div", {
    className: classes.root
  }, /* @__PURE__ */ React__default['default'].createElement(TextField__default['default'], {
    disabled: disabled,
    fullWidth: fullWidth,
    label: label,
    value: value,
    onChange: handleChange,
    name: "numberformat",
    id: "formatted-numberformat-input",
    InputProps: {
      inputComponent: NumberFormatCustom,
      inputProps: {
        decimalScale2: decimalScale,
        intScale: intScale,
        readOnly: readOnly
      },
      endAdornment: /* @__PURE__ */ React__default['default'].createElement(InputAdornment__default['default'], {
        position: "end"
      }, endAdornment)
    },
    variant: "standard"
  }));
}

module.exports = FormattedInputs;
